export type IGetUserType = {
	isCorporate: boolean;
};

const model: types.models.IInputModel = {
	response: 'response',
	isCorporate: 'response.getUserType.isCorporate',
};

export default model;
